import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { Event } from '@swf/sports/components/Event/Event';
import { useEventMarketTemplatesWidget } from '@swf/sports/models/market-templates/eventBased';
import type {
  MarketTemplateComponent,
  SingleMarketTemplateProps
} from '@swf/sports/types/templates';

export const EventRow: MarketTemplateComponent<SingleMarketTemplateProps> = ({ marketId }) => {
  const { widgetSelect } = useEventMarketTemplatesWidget();
  const market = useSelector((state: RootState) => widgetSelect.market(state, marketId));
  const event = useSelector((state: RootState) => widgetSelect.event(state, market?.eventId ?? -1));

  if (!market?.competitionId) return null;

  return (
    <li data-testid="event">
      <Event event={event} market={market} />
    </li>
  );
};

EventRow.marketTemplateType = 'EVENT';

export default EventRow;
